import { commentItems } from '@/mocks/homeData';

const avatarColors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-primary-400', 'bg-accent-400'];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            读者声音
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">用户评论</h2>
          <p className="text-sm text-foreground-600 mt-2">看看其他吃瓜群众怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold text-background-50 shrink-0 ${avatarColors[i % avatarColors.length]}`}
                >
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}